export const homepageCarouselHeightDesktop = () => {
    if (!($('body #homepage-carousel img').attr('src') == '')) $('body #homepage-carousel').css({
        'height': '100%'
    });
};
